// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"1ce2902a","410":"badcec44","440":"528fa781","455":"949e9dc9","488":"dc27bfb4","503":"2142d519","593":"3f17ab01","612":"e6a6d715","733":"16b617fb","804":"72d4e682","860":"41f94d6c","883":"024a1291","953":"1b029036","977":"87cb53c9"}[chunkId] + ".chunk.js";
};